import { render, staticRenderFns } from "./Wap_RHD008_Produce.vue?vue&type=template&id=6baba58e&scoped=true&"
import script from "./Wap_RHD008_Produce.vue?vue&type=script&lang=js&"
export * from "./Wap_RHD008_Produce.vue?vue&type=script&lang=js&"
import style0 from "./Wap_RHD008_Produce.vue?vue&type=style&index=0&id=6baba58e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6baba58e",
  null
  
)

export default component.exports